(function () {
  'use strict';

  function formatMoney(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents);
      } catch (error) {
        // Continue with Intl when the active theme does not expose a money format.
      }
    }

    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: currency || 'MXN',
      maximumFractionDigits: 0
    }).format(Number(cents || 0) / 100);
  }

  function parseVariants(form) {
    var node = form.querySelector('[data-nmn-variants]');
    if (!node) return [];

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return [];
    }
  }

  function updatePurchase(purchase, variant, currency) {
    if (!purchase || !variant) return;

    var price = purchase.querySelector('[data-nmn-price]');
    var compare = purchase.querySelector('[data-nmn-compare-price]');
    var stock = purchase.querySelector('[data-nmn-stock]');
    var add = purchase.querySelector('[data-nmn-add]');
    var label = purchase.querySelector('[data-nmn-add-label]');

    if (price) price.textContent = formatMoney(variant.price, currency);

    if (compare) {
      var hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      compare.hidden = !hasCompare;
      compare.textContent = hasCompare ? formatMoney(variant.compare_at_price, currency) : '';
    }

    if (stock) {
      stock.textContent = variant.available ? 'Disponible para compra' : 'Agotado temporalmente';
      stock.classList.toggle('is-unavailable', !variant.available);
    }

    if (add) add.disabled = !variant.available;
    if (label) label.textContent = variant.available ? 'QUIERO MI NMN + RESVERATROL' : 'AGOTADO';
  }

  function initVariantSelectors(root) {
    var currency = root.getAttribute('data-currency') || 'MXN';

    root.querySelectorAll('[data-nmn-form]').forEach(function (form) {
      var variants = parseVariants(form);
      var select = form.querySelector('[data-nmn-variant-select]');
      if (!select || !variants.length) return;

      select.addEventListener('change', function () {
        var variant = variants.find(function (item) {
          return String(item.id) === String(select.value);
        });
        if (!variant) return;

        root.querySelectorAll('[data-nmn-variant-select]').forEach(function (otherSelect) {
          if (otherSelect.querySelector('option[value="' + variant.id + '"]')) {
            otherSelect.value = String(variant.id);
          }
        });

        root.querySelectorAll('[data-nmn-purchase]').forEach(function (purchase) {
          updatePurchase(purchase, variant, currency);
        });

        root.querySelectorAll('[data-nmn-sticky-price]').forEach(function (node) {
          node.textContent = formatMoney(variant.price, currency);
        });
      });
    });
  }

  function initQuantities(root) {
    root.querySelectorAll('[data-nmn-quantity]').forEach(function (quantity) {
      var input = quantity.querySelector('[data-nmn-qty-input]');
      var minus = quantity.querySelector('[data-nmn-qty-minus]');
      var plus = quantity.querySelector('[data-nmn-qty-plus]');
      if (!input || !minus || !plus) return;

      minus.addEventListener('click', function () {
        input.value = Math.max(1, Number(input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      plus.addEventListener('click', function () {
        input.value = Math.max(1, Number(input.value || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('change', function () {
        input.value = Math.max(1, Math.floor(Number(input.value || 1)));
      });
    });
  }

  function initAccordion(root) {
    root.querySelectorAll('[data-nmn-accordion]').forEach(function (accordion) {
      accordion.querySelectorAll('details').forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          accordion.querySelectorAll('details').forEach(function (other) {
            if (other !== details) other.open = false;
          });
        });
      });
    });
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-nmn-sticky]');
    var hero = root.querySelector('[data-nmn-hero]');
    var offer = root.querySelector('[data-nmn-offer]');
    var footer = root.querySelector('[data-nmn-footer]');
    if (!sticky || !hero) return;

    sticky.hidden = false;
    var queued = false;

    function intersectsViewport(element) {
      if (!element) return false;
      var rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function update() {
      queued = false;
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var threshold = hero.offsetTop + hero.offsetHeight * 0.25;
      var shouldShow = isMobile && window.scrollY > threshold;
      if (intersectsViewport(offer) || intersectsViewport(footer)) shouldShow = false;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function requestUpdate() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-nmn-ready') === 'true') return;
    root.setAttribute('data-nmn-ready', 'true');

    document.body.classList.add('nmn-landing-active');
    if (root.getAttribute('data-hide-theme-header') === 'true') {
      document.body.classList.add('nmn-hide-theme-header');
    }
    if (root.getAttribute('data-hide-theme-footer') === 'true') {
      document.body.classList.add('nmn-hide-theme-footer');
    }

    initQuantities(root);
    initVariantSelectors(root);
    initAccordion(root);
    initSticky(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nmn-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(function () {
      if (!document.querySelector('[data-nmn-root]')) {
        document.body.classList.remove('nmn-landing-active', 'nmn-hide-theme-header', 'nmn-hide-theme-footer');
      }
    }, 0);
  });
})();
